import type { FormVariant } from './config'
import { useForm } from './FormProvider'

export const FormItem: FormVariant['item'] = props => {
  const { variant } = useForm()
  return variant.item(props)
}
